import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const Bus2: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m630 586.17c-33.08 0-60-26.92-60-60s26.92-60 60-60 60 26.92 60 60-26.92 60-60 60zm0-90c-16.54 0-30 13.46-30 30s13.46 30 30 30 30-13.46 30-30-13.46-30-30-30zm-479.77 90c-33.08 0-60-26.92-60-60s26.92-60 60-60 60 26.92 60 60-26.92 60-60 60zm0-90c-16.54 0-30 13.46-30 30s13.46 30 30 30 30-13.46 30-30-13.46-30-30-30z' />
    <path d='m750 541.17h-75v-30h45v-195c0-24.81-20.19-45-45-45h-550.49l-59.52 119.04a45.194 45.194 0 0 0 -4.75 20.12v100.84h45v30h-75.01v-130.84c0-11.58 2.74-23.18 7.92-33.54l67.81-135.62h569.04c41.36 0 75 33.64 75 75z' />
    <path d='m190.23 511.17h399.77v30h-399.77z' />
    <path d='m570 330h-120v-30h90c16.57 0 30 13.43 30 30z' />
    <path d='m90 300.59h380v30h-380z' transform='matrix(.99999507 -.00314159 .00314159 .99999507 -.969999 .869999)' />
    <path d='m480 421.17h-430v-30h400v-71.17h30z' />
    <path d='m180 315h30v80h-30z' />
    <path d='m315 315h30v80h-30z' />
  </IconBase>
));

Bus2.displayName = 'Bus2';

export default Bus2;
